'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  INIT: 'redux-localstorage/INIT'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-localstorage/lib/actionTypes.js
// module id = 109
// module chunks = 18